




















import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {Action, Mutation, Getter} from 'vuex-class'
import TYPES from 'TYPES'
import KNB from "@dp/knb";
import {Dialog} from 'vant';

@Component({
  components: {}
})

export default class Order extends Vue {
  @Action(TYPES.POST_FORBIDDEN_MIS) postForbiddenMisAc

  show: boolean = true
  message: string = '点击确认后，将退出并无法登录所有公司系统，找回账户需要直接上级或身边同事联系6000协助，请确认是否继续。'

  created() {
    // Dialog.confirm({
    //   messageAlign:'left',
    //   title: '警告!',
    //   confirmButtonColor:'#ee0a24',
    //   cancelButtonColor:'rgba(69, 90, 100, 0.6)',
    //   message: '       该功能仅限于遇到信息安全风险的情况下使用，使用后将<label style="color: #ee0a24;font-size: larger">封禁</label>公司所有信息系统（包括大象、邮件）的权限，解封需要通过直属leader发起。</br></br>是否确定要锁定MIS账号？',
    // })
    //   .then(() => {
    //     this.confirm();
    //   })
    //   .catch(() => {
    //     this.cancel();
    //   });
  }

  confirm() {
    window.location.href = "https://prophet.meituan.com/account/stopMyAccount"
  }

  cancel() {
    KNB.closePage({});
  }
}
